import { render, staticRenderFns } from "./curriculumCMS.vue?vue&type=template&id=552868cf&scoped=true"
import script from "./curriculumCMS.vue?vue&type=script&lang=js"
export * from "./curriculumCMS.vue?vue&type=script&lang=js"
import style0 from "./curriculumCMS.vue?vue&type=style&index=0&id=552868cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552868cf",
  null
  
)

export default component.exports